import classNames from 'classnames';
import { CtaButton } from '@/components/Cta/Cta';
import TradeInBarLink from '@/components/tradein/TradeInBarLink';
import { priceFormater } from '@/settings';
import i18n from '@/settings/i18n';
import { priceFormatSuperscript } from '@/lib/price';

const t = i18n.init('cart');

const StickyCheckoutBar = ({
  totalLabel,
  itemCount,
  total,
  loading,
  onCheckout,
  compact = false,
}: {
  totalLabel: string;
  /** Devices and accessories, as the summary's Items row counts them. */
  itemCount: number;
  total: number;
  loading: boolean;
  onCheckout: () => void;
  /** The purchase flow's: the same bar as the accessories page's. */
  compact?: boolean;
}) => (
  <div
    className={classNames(
      'fixed bottom-0 left-0 z-[70] w-full bg-white pb-[env(safe-area-inset-bottom)] lg:hidden',
      compact
        ? 'border-t border-[#E6E7EB]'
        : 'shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1),0_-2px_4px_-2px_rgba(0,0,0,0.1)]',
    )}
  >
    <div
      className={classNames(
        'flex items-center justify-between gap-4',
        compact ? 'reebelo-container py-3' : 'mx-auto px-5 py-4',
      )}
    >
      <div className="space-y-0.5">
        <div
          className={classNames(
            'leading-tight',
            compact ? 'text-xs text-gray-700/60' : 'text-sm',
          )}
        >
          {totalLabel}{' '}
          <span className={classNames(!compact && 'text-gray-700/75')}>
            ({itemCount} {itemCount === 1 ? t`item` : t`items`})
          </span>
        </div>
        <div className="flex items-end gap-3">
          <div className="text-lg font-bold leading-tight" translate="no">
            {priceFormatSuperscript(priceFormater.long(total))}
          </div>
          {compact && <TradeInBarLink className="leading-tight" />}
        </div>
      </div>
      <CtaButton
        variant="dark"
        loading={loading}
        onClick={onCheckout}
        id="e2e-cart-sticky-checkout-btn"
        className={classNames(
          'font-bold',
          compact
            ? '!my-0 !h-12 !rounded-md !px-6 !py-0 !text-sm'
            : 'min-w-[160px] flex-1 !rounded-xl !py-4 xs:max-w-[240px]',
        )}
      >
        {t`Checkout`}
      </CtaButton>
    </div>
  </div>
);

export default StickyCheckoutBar;
